// @flow

import ActivatePassword from "./ActivateUser";

export default ActivatePassword;
